module.exports = __webpack_public_path__ + "static/img/digitalsystem1.c6456109.png";